import webstomp from 'webstomp-client';
import SockJS from 'sockjs-client/dist/sockjs.min.js';
import { useUserStore } from '/@/store/modules/user';
import { watch } from 'vue';
import { websocketUrlForNotify } from '/@/api/business/notify';
import { PollingTime } from '/@/enums/appEnum';
export function useSocket(HandleNotifys) {
  const userStore = useUserStore();
  let connectCount = 0;
  let stomp: any = undefined;

  const transFn = (res) => {
    const body = JSON.parse(res.body);
    const language = useUserStore()?.getUserInfo?.user?.language?.slice(0, 2) || 'en';
    for (const key in body.title) {
      if (key.slice(0, 2) === language) {
        body.title = body.title[key];
      }
    }
    for (const key in body.content) {
      if (key.slice(0, 2) === language) {
        body.content = body.content[key];
      }
    }
    return body;
  };

  const connect = async () => {
    // if (location.href.includes('localhost')) {
    //   return;
    // }
    const urlPrefix = websocketUrlForNotify();
    const sockJs = new SockJS(urlPrefix);
    stomp = webstomp.over(sockJs, { debug: false });
    const token = userStore.getToken;
    stomp.connect(
      { token: token },
      // connectCallback
      () => {
        connectCount = 0;

        stomp.subscribe('/basicai/topic/site', function (response) {
          HandleNotifys(transFn(response));
        });

        stomp.subscribe(
          '/basicai/topic/team/' + userStore.getUserInfo?.team?.id,
          function (response) {
            HandleNotifys(transFn(response));
          },
        );

        stomp.subscribe(
          '/basicai/topic/user/' + userStore.getUserInfo?.user?.id,
          function (response) {
            HandleNotifys(transFn(response));
          },
        );

        stomp.subscribe('/user/basicai/queue/errors', function (response) {
          HandleNotifys(transFn(response));
        });
      },
      // errorCallback
      () => {
        // 断线重连
        setTimeout(() => {
          stomp = undefined;
          if (connectCount < 20) {
            connectCount = connectCount + 1;
            connect();
          }
        }, PollingTime.short);
      },
    );
  };

  function disconnect() {
    // debugger;
    if (stomp != undefined) {
      stomp.disconnect(function () {
        console.log('Client disconnected');
      });
      stomp = undefined;
      // 中断未连接成功的心跳请求
      connectCount = Infinity;
    } else {
      connectCount = Infinity;
    }
    console.log('distory', connectCount);
  }

  watch(
    () => userStore.getToken,
    (token) => {
      if (!token) {
        disconnect();
      }
    },
  );

  return { connect, disconnect };
}
